import api from '@/api';
import { Part } from '../Parts/Parts.types';

import { API_BASE_URL } from '..';
import { PageResult } from '@/core/request/PageResult';
const CONTROLLER_URL = `${API_BASE_URL}/parts`;

export async function getPartReplacements(obj: {
  CompaniesIds?: string;
  partId: number;
}): Promise<PageResult<Part>> {
  const { partId, ...objRequest } = obj;

  const result = (await api.get(`${CONTROLLER_URL}/replacements/${partId}`, {
    ...objRequest,
  })) as unknown;

  return result as PageResult<Part>;
}

export async function createPartReplacements(obj: {
  replacementId?: number;
  partId?: number;
}): Promise<Part> {
  const { partId, replacementId } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/replacements/${partId}`,
    { replacementId },
    null,
  )) as unknown;

  return result as Part;
}

export async function deletePartReplacements(obj: { replacementId: number }) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/replacements/${obj.replacementId}`,
    {},
    null,
  )) as unknown;

  return result;
}
